import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import { withTheme } from "styled-components";

import { anonymised } from "commons/src/NucleusTheme";

function LargeOnlyComponent({ children, enabled = true, theme = anonymised }) {
    const isLargeDisplay = useMediaQuery({
        minWidth: theme.minWidth,
        screen: true
    });
    const isPrint = useMediaQuery({ print: true });

    if (enabled) {
        return isLargeDisplay || isPrint ? children : null;
    }
    return children;
}

LargeOnlyComponent.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    enabled: PropTypes.bool,
    theme: PropTypes.shape({
        minWidth: PropTypes.string
    })
};

export const LargeOnly = withTheme(LargeOnlyComponent);
